// AppointmentModal.js
import { useCallback, useEffect, useRef, useState } from "react";
import {
  Input,
  Radio,
  Select,
  Checkbox,
  Typography,
  List,
  message,
  Space,
  Avatar,
} from "antd";
import { Modal, Button, Form, Row, Col, Tabs, Tab } from "react-bootstrap";
import { UserAddOutlined, UserOutlined } from "@ant-design/icons";

import AddPatientPopup from "./AddPatientPopUp";
import PropTypes from "prop-types";
import axios from "axios";
import {
  bookAppointment,
  getPatientList,
} from "../../services/receptionist/book appointment/bookappointment";
import { doctor01, male, patient, searchPatient } from "../imagepath";
import { getShifts } from "../../services/doctor/shift schedule/shift_schedule";
import { useAuth } from "../../services/authentication_API/authService";
import Loader from "../Loader";
import dayjs from "dayjs";
import { useMessageApi } from "../../services/message api/MessageProvider";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;
const { Option } = Select;

const AppointmentModal = ({
  showModal,
  setShowModal,
  doctor,
  selectedSlot,
  selectedDate,
  step,
  setStep,
  booking_type,
}) => {
  const { userData } = useAuth();

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [newPatientInput, setNewPatientInput] = useState("");
  const [newPatientDetails, setNewPatientDetails] = useState("");
  const isAddPatientDisabled =
    !newPatientInput.trim() || !newPatientDetails.trim();
  const [stats, setStats] = useState([]);
  const [selectedslot, setSelectedSlot] = useState(selectedSlot);
  const [loading, setLoading] = useState(false);
  const messageApi = useMessageApi();
  const navigate = useNavigate();

  console.log("selected slot", selectedslot);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getShifts(doctor?.id);
        if (result.success) {
          console.log("Fetched Data:", result?.data);
          setStats(result?.data);
        } else {
          console.error("Error:", result.error || "Failed to fetch shifts");
        }
      } catch (err) {
        console.error("Exception:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (selectedslot === undefined || selectedslot === null) {
    const now = new Date();

    // Convert "hh:mm AM/PM" to minutes
    const timeToMinutes = (timeStr) => {
      const [time, period] = timeStr.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      return hours * 60 + minutes;
    };

    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    console.log("Current Time in Minutes:", currentMinutes);

    for (let index = 0; index < stats?.length; index++) {
      const shift = stats[index];

      const shiftEndMinutes = timeToMinutes(shift.end_time);
      console.log("Shift End:", shift.end_time, "=>", shiftEndMinutes);

      if (shiftEndMinutes > currentMinutes) {
        const availableSlot = shift?.time_slots?.find((slot) => {
          const slotStartMinutes = timeToMinutes(slot.slot_start_time);

          // const isNotBlocked = slot.blocked === 0;
          const isNotBooked = !slot.booked;
          const isTimeOk = slotStartMinutes >= currentMinutes;
          console.log(isNotBooked, isTimeOk);

          console.log(
            `Slot ${slot.slot_number}:`,
            slot.slot_start_time,
            "=>",
            slotStartMinutes,
            "| Available:",
            isNotBooked && isTimeOk,
          );

          return isNotBooked && isTimeOk;
        });

        if (availableSlot) {
          console.log("Selected slot for walk-in booking:", availableSlot);
          setSelectedSlot({
            ...availableSlot,
            shift_id: shift?.id, // ✅ add the shift ID here
          });
          break;
        }
      }
    }
  }

  const today = new Date();
  // const formatted = today.toISOString().split('T')[0];
  const formatted = selectedDate
    ? selectedDate.format("YYYY-MM-DD")
    : today.toISOString().split("T")[0];
  const searchTimeoutRef = useRef(null);
  const handleSearch = async (value) => {
    // 1. Update UI states immediately for a responsive input
    setSearchQuery(value);
    setNewPatientDetails(value);

    // 2. Clear any existing timer from previous keystrokes
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    const query = value.trim();

    // 3. If query is too short, reset results immediately and don't trigger API
    if (query.length < 3) {
      setFilteredPatients([]);
      return;
    }

    // 4. Start a new timer for the API call

    searchTimeoutRef.current = setTimeout(async () => {
      try {
        console.log("Executing debounced API call for:", query);
        const result = await getPatientList(query);

        if (result.success) {
          setFilteredPatients(result?.data || []);
        }
      } catch (err) {
        console.error("Search Exception:", err.message);
      }
    }, 500); // 500ms delay
  };
  // const handleSubmit = () => {
  //   const appointmentData = {
  //     doctor_id:doctor?.id,
  //     patient_id: selectedPatient?.id,
  //     shift_id: selectedslot?.shift_id,
  //     slot_number:selectedslot.slot_number,
  //     appointment_date:formatted,
  //     appointment_time: selectedslot.slot_start_time,
  //     status:"Queue",
  //     reason_for_appointment: reason,
  //   };
  //   console.log("Appointment submitted:", appointmentData);
  //   // Close modal and reset all states:
  //   setShowModal(false);
  //   setStep("search");
  //   setSearchQuery("");
  //   setFilteredPatients([]);
  //   setSelectedPatient(null);
  //   setReason("");
  //   setOtherReason("");
  // };
  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: "topRight", // <-- key part for right side
  });
  // const [messageApi, contextHolder] = message.useMessage();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const appointmentData = {
        doctor_id: doctor?.id,
        patient_id: selectedPatient?.id,
        shift_id: selectedslot?.shift_id || 0,
        slot_number: selectedslot?.slot_number || 0,
        appointment_date: formatted,
        appointment_time:
          selectedslot?.slot_start_time || dayjs().format("HH:mm"),
        status: booking_type === "walkin" ? "Arrival" : "Queue",
        reason_for_appointment: reason,
      };
      const result = await bookAppointment(appointmentData);
      if (result.success) {
        messageApi.open({
          type: "success",
          content: "Booked Appointment successfully!",
        });
        setLoading(false);
        setShowModal(false);
        setStep("search");
        setSearchQuery("");
        setFilteredPatients([]);
        setSelectedPatient(null);
        setReason("");
        setOtherReason("");
      } else {
        const errors = result?.error;
        const messageArray = Array.isArray(errors) ? errors : [errors];

        messageArray.entries(errors).forEach(([field, messages]) => {
          const messageArray = Array.isArray(messages) ? messages : [messages];

          Array.isArray(messageArray)
            ? messageArray.forEach(async (msg) => {
                messageApi.open({
                  type: "error",
                  content: `${field}: ${msg}`,
                  style: {
                    maxWidth: "300px",
                    minWidth: "300px",
                    textAlign: "left",
                    wordBreak: "break-word",
                    marginLeft: "auto",
                    marginRight: "0",
                  },
                });
              })
            : messageArray &&
              messageApi.open({
                type: "error",
                content: `${field}: ${messageArray}`,
                // style: {
                //   maxWidth: "300px",
                //   minWidth: "300px",
                //   textAlign: "left",
                //   wordBreak: "break-word",
                //   marginLeft: "auto",
                //   marginRight: "0",
                // },
              });
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error adding hospital:", error?.message);
      // Show error to user
    }
  };

  const handleCancel = () => {
    console.log("Current step:", step);
    if (step === "confirm") {
      setStep("search");
      setSelectedPatient(null);
    } else {
      setShowModal(false);
      setSearchQuery("");
      setFilteredPatients([]);
      setSelectedPatient(null);
    }
  };

  const [numberOfExtraSlots, setNumberOfExtraSlots] = useState(5);
  // State for radio selection: "before" or "after"
  const [slotPosition, setSlotPosition] = useState("after"); // default "after shift"
  // State for the checkbox: allow online booking
  const [allowOnlineBooking, setAllowOnlineBooking] = useState(true);

  // Generate slot numbers based on the selected number.
  // In the image, the numbers are 121, 122, 123, 124, 125 when 5 slots are selected.
  const generateSlotNumbers = (count) => {
    const start = 121; // starting number as in image
    let slots = [];
    for (let i = 0; i < count; i++) {
      slots.push(start + i);
    }
    return slots;
  };

  const slotNumbers = generateSlotNumbers(numberOfExtraSlots);

  // Handler for "Add Slots" button (simulate submission)
  const handleAddSlots = () => {
    const data = {
      numberOfExtraSlots,
      slotPosition,
      allowOnlineBooking,
      slotNumbers,
    };
    console.log("Adding extra slots with data:", data);
    // You can add API integration here if needed.
    setShowModal(false);
  };

  const [showPopup, setShowPopup] = useState(false);

  // const handleAddPatient = () => {
  //   setShowPopup(true);
  //   // setNewPatientInput("");
  //   // setSearchQuery("");
  //   // setFilteredPatients([]);
  // };

  const [duplicatePatients, setDuplicatePatients] = useState([]);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);

  const handleAddPatient = useCallback(async () => {
    // Check if mobile number exists in the system (search by mobile only)
    try {
      const result = await getPatientList(newPatientInput);

      if (result.success && result?.data?.length > 0) {
        // Filter to get only patients with exact mobile number match
        const patientsWithSameMobile = result?.data?.filter(
          (patient) => patient.mobile === newPatientInput,
        );

        // If patients with same mobile number exist, show the duplicate popup
        if (patientsWithSameMobile.length > 0) {
          setDuplicatePatients(patientsWithSameMobile);
          setShowDuplicatePopup(true);
          return;
        }
      }

      // If no existing patients with same mobile, proceed to add new patient
      setShowPopup(true);
    } catch (err) {
      console.error("Error checking for duplicate patients:", err.message);
      // On error, proceed to add new patient
      setShowPopup(true);
    }
  }, [newPatientInput]);

  const handleClosePopup = useCallback((patients) => {
    setShowPopup(false);
    // setSelectedPatient(patients);
    // setStep("confirm");
  }, []);

  const handleDuplicatePopupConfirm = useCallback(() => {
    // User clicked confirm - open AddPatientPopup
    setShowDuplicatePopup(false);
    setShowPopup(true);
  }, []);

  const handleDuplicatePopupCancel = useCallback(() => {
    // User clicked back/cancel on duplicate popup
    setShowDuplicatePopup(false);
    setDuplicatePatients([]);
  }, []);

  return (
    <>
      {/* Duplicate Patients Popup */}
      {showDuplicatePopup && (
        <Modal
          show={showDuplicatePopup}
          onHide={handleDuplicatePopupCancel}
          centered
          size="lg"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header
            closeButton
            style={{ borderBottom: "2px solid #f0f0f0" }}
          >
            <Modal.Title style={{ fontSize: "18px", fontWeight: "600" }}>
              <span style={{ color: "#1890ff" }}>ℹ️</span> Patient(s) Found with
              Mobile: {newPatientInput}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ minHeight: "auto", padding: "24px" }}>
            <div style={{ marginBottom: "16px" }}>
              <Text style={{ fontSize: "14px", color: "#666" }}>
                We found the following patient(s) with this mobile number:
              </Text>
            </div>
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                maxHeight: "400px",
                minHeight: "200px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {duplicatePatients.map((patient) => (
                  <div
                    key={patient.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "16px",
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      borderRadius: "8px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {/* Avatar */}
                    <Avatar
                      size={48}
                      icon={<UserOutlined />}
                      style={{
                        marginRight: "16px",
                        backgroundColor: "#87d068",
                        flexShrink: 0,
                      }}
                    />

                    {/* Patient Details in Single Line */}
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: "24px",
                      }}
                    >
                      <div style={{ minWidth: "180px" }}>
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                            color: "#262626",
                          }}
                        >
                          {patient.first_name} {patient.last_name}
                        </div>
                      </div>

                      <div style={{ minWidth: "120px" }}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: "13px" }}
                        >
                          <strong>Mobile:</strong> {patient.mobile}
                        </Typography.Text>
                      </div>

                      <div style={{ minWidth: "150px" }}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: "13px" }}
                        >
                          <strong>DOB:</strong>{" "}
                          {patient?.date_of_birth || "N/A"}
                        </Typography.Text>
                      </div>

                      <div style={{ minWidth: "120px" }}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: "13px" }}
                        >
                          <strong>ID:</strong> {patient?.office_id || "N/A"}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{ borderTop: "2px solid #f0f0f0", padding: "16px 24px" }}
          >
            <Button
              onClick={handleDuplicatePopupCancel}
              style={{
                borderRadius: "6px",
                height: "38px",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              ← Back
            </Button>
            <Button
              type="primary"
              onClick={handleDuplicatePopupConfirm}
              style={{
                borderRadius: "6px",
                height: "38px",
                fontSize: "14px",
                fontWeight: "500",
                minWidth: "100px",
              }}
            >
              Confirm →
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Add New Patient Popup */}
      {showPopup && (
        <AddPatientPopup
          show={showPopup}
          handleClose={handleClosePopup}
          patientName={newPatientDetails}
          patientMobile={newPatientInput}
        />
      )}

      {loading ? (
        <Loader />
      ) : (
        <Modal
          show={showModal}
          maskClosable={false}
          keyboard={false}
          onHide={handleCancel}
          centered
          size={step == "search" ? "lg" : undefined}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {step === "search"
                ? `Select Patient for Token ${selectedslot?.slot_number}`
                : step == "confirm"
                  ? "Confirm for Token"
                  : "Add Extra Slots"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ minHeight: "500px" }}>
            {step === "search" ? (
              <>
                {searchQuery?.trim().length >= 3 ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <Input
                      type="text"
                      placeholder="Patient Name/Mobile Number/Date of Birth/Office ID"
                      value={searchQuery}
                      onChange={(e) => handleSearch(e.target.value)}
                      autoFocus
                      style={{
                        flex: 1,
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <Input
                      placeholder="Mobile no"
                      value={newPatientInput}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                        if (value.length <= 10) setNewPatientInput(value);
                      }}
                      maxLength={10}
                      style={{
                        flex: 1,
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
                ) : (
                  <>
                    <Input
                      type="text"
                      placeholder="Patient Name/Mobile Number/Date of Birth/Office ID"
                      value={searchQuery}
                      onChange={(e) => handleSearch(e.target.value)}
                      autoFocus
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        marginBottom: "10px",
                      }}
                    />
                  </>
                )}

                {filteredPatients.length > 0 ? (
                  <div
                    style={{
                      flex: 1,
                      overflowY: "scroll",
                      maxHeight: "400px",
                      minHeight: "400px",
                      marginTop: "10px",
                    }}
                  >
                    <List
                      dataSource={filteredPatients}
                      bordered
                      renderItem={(patient) => (
                        <List.Item
                          key={patient.officeId}
                          style={{
                            display: "flex",

                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "12px 20px", // Increased padding for better visual spacing
                          }}
                        >
                          {/* 1. Patient Details (Left Side) */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minWidth: "200px",
                            }}
                          >
                            {" "}
                            {/* Adjust minWidth as needed */}
                            {/* Avatar Placeholder */}
                            <Avatar
                              size="large"
                              icon={<UserOutlined />} // Use a generic user icon for now
                              // If patient has an image URL: src={patient.avatarUrl}
                              style={{ marginRight: "15px" }}
                            />
                            <div>
                              <div
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {patient.first_name} {patient.last_name}
                              </div>
                              <Typography.Text
                                type="secondary"
                                style={{ fontSize: "13px" }}
                              >
                                {patient.mobile}
                              </Typography.Text>
                            </div>
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <div
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              {patient?.date_of_birth || patient?.age}
                            </div>
                            <div>
                              {/* Using Ant Design Typography.Text for cleaner styling */}
                              <Typography.Text type="secondary">
                                {patient?.office_id}
                              </Typography.Text>
                            </div>
                          </div>

                          {/* 2. Action Buttons (Right Side) */}
                          <Space size="small">
                            {" "}
                            {/* Use Space for automatic button spacing */}
                            <Button
                              type="default" // Changed to default for "View Profile"
                              size="small"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/patientsprofile", {
                                  state: {
                                    patient: patient, // Pass the current 'patient' object under the key 'patient'
                                  },
                                });
                              }}
                            >
                              View Profile
                            </Button>
                            <Button
                              type="primary" // Keeping primary for the main action
                              size="small"
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedPatient(patient);
                                setStep("confirm");
                              }}
                            >
                              Select Patient
                            </Button>
                          </Space>
                        </List.Item>
                      )}
                    />
                  </div>
                ) : (
                  searchQuery && (
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      <Text type="secondary">No matches found.</Text>
                    </div>
                  )
                )}
                {searchQuery == 0 && (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <img
                      src={searchPatient}
                      alt="Doctor Icon"
                      style={{
                        width: "250px",
                        height: "250px",
                        marginBottom: "5px",
                      }}
                    />
                    <p>Search for your patients</p>
                  </div>
                )}
              </>
            ) : step === "confirm" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <img
                      src={doctor01}
                      alt="Doctor"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                      }}
                    />
                    <h4 style={{ margin: "8px 0 0" }}>{doctor.name}</h4>
                    <Text type="secondary">Doctor</Text>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <Text type="secondary">Appointment Time</Text>
                    <h4 style={{ margin: "8px 0" }}>
                      {selectedslot?.slot_start_time}
                    </h4>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <img
                      src={patient || "patient_placeholder.png"}
                      alt="Patient"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                      }}
                    />
                    <h4 style={{ margin: "8px 0 0" }}>
                      {selectedPatient?.first_name} {selectedPatient?.last_name}
                    </h4>
                    <Text type="secondary">{selectedPatient?.mobile}</Text>
                  </div>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <h5>Reason for Appointment</h5>
                  <Radio.Group
                    onChange={(e) => setReason(e.target.value)}
                    value={reason}
                  >
                    <Radio value="Consultation">Consultation</Radio>
                    <Radio value="Follow Up">Follow Up</Radio>
                    <Radio value="Vaccination">Vaccination</Radio>
                    <Radio value="Other">Other</Radio>
                  </Radio.Group>
                  {reason === "Other" && (
                    <Input
                      placeholder="Please specify the reason"
                      style={{ marginTop: "10px" }}
                      value={otherReason}
                      onChange={(e) => setOtherReason(e.target.value)}
                    />
                  )}
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: "100%",
                    maxWidth: "700px",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Text strong style={{ minWidth: "200px" }}>
                      Number of extra slots:
                    </Text>
                    <Select
                      value={numberOfExtraSlots}
                      onChange={(value) => setNumberOfExtraSlots(value)}
                      style={{ width: 120 }}
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                        <Option key={num} value={num}>
                          {num}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div>
                    <Radio.Group
                      value={slotPosition}
                      onChange={(e) => setSlotPosition(e.target.value)}
                    >
                      <Radio value="before">Add slots before shift</Radio>
                      <Radio value="after">Add slots after shift</Radio>
                    </Radio.Group>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    {slotNumbers.map((slot, index) => (
                      <div
                        key={index}
                        style={{
                          padding: "10px 15px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          background: "#fff",
                          fontWeight: "bold",
                          minWidth: "50px",
                          textAlign: "center",
                        }}
                      >
                        {slot}
                      </div>
                    ))}
                  </div>

                  <div>
                    <Checkbox
                      checked={allowOnlineBooking}
                      onChange={(e) => setAllowOnlineBooking(e.target.checked)}
                    >
                      Allow online booking
                    </Checkbox>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {step === "confirm" ? (
              <>
                <Button type="primary" onClick={handleSubmit}>
                  Book Appointment
                </Button>
              </>
            ) : step === "search" ? (
              <>
                {searchQuery && (
                  <>
                    <UserAddOutlined
                      style={{
                        fontSize: "20px",
                        color: "#aaa",
                        borderRadius: "50%",
                        background: "#f0f0f0",
                        padding: "10px",
                        marginBottom: "5px",
                      }}
                    />
                    <div
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                        borderRadius: "8px",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      <Text> {newPatientDetails}</Text>
                      <br />
                      <Text> {newPatientInput}</Text>
                    </div>
                  </>
                )}
                {searchQuery && (
                  <>
                    <Button
                      type="primary"
                      disabled={isAddPatientDisabled}
                      onClick={handleAddPatient}
                    >
                      Add Patient
                    </Button>
                    {showPopup && (
                      <AddPatientPopup
                        show={showPopup}
                        handleClose={handleClosePopup}
                        patientName={newPatientDetails}
                        patientMobile={newPatientInput}
                      />
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <Button type="primary" onClick={handleAddSlots}>
                  Add Slots
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default AppointmentModal;

AppointmentModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  selectedSlot: PropTypes.object,

  doctor: PropTypes.object.isRequired,

  handleSubmit: PropTypes.func,
  step: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  selectedDate: PropTypes.object.isRequired,
  booking_type: PropTypes.string.isRequired,
};
